module.exports = __webpack_public_path__ + "static/media/contract_writing.34680bd6.svg";